import React, { FC, useEffect } from "react";

import { useEmbedParametersContext } from "../../contexts/EmbedParametersContext";
import { useMediaContext } from "../../contexts/MediaContext";
import { State } from "../../enums";
import { timeText } from "../../helpers/preview-text";
import i18n from "../../service/i18n";
import { PlayerRefreshEvent } from "../../types/common";
import NotAllowed from "../NotAllowed";

import { Error } from "./Error";
import { Identification } from "./Identification";
import { NonPlayableContent } from "./NonPlayableContent";
import { TextNoWrap } from "./NonPlayableStyles";
import { PendingEvent } from "./PendingEvent";

const PendingOnDemand = () => {
  const { language } = useEmbedParametersContext();
  const { startTime } = useMediaContext();
  return (
    <NonPlayableContent>
      {i18n("ohjelma_on_tulossa_katsottavaksi", { language })}{" "}
      <TextNoWrap>{timeText(language, startTime)}</TextNoWrap>.
    </NonPlayableContent>
  );
};

const Gone = () => {
  const { language } = useEmbedParametersContext();
  return (
    <NonPlayableContent>
      {i18n("ohjelman_katseluaika_on_paattynyt", { language })}.
    </NonPlayableContent>
  );
};

const Blocked = () => {
  const { language } = useEmbedParametersContext();
  return (
    <NonPlayableContent>
      {i18n("ohjelma_ei_ole_katsottavissa_ulkomailla", { language })}.
    </NonPlayableContent>
  );
};

interface Props {
  refreshComponent: PlayerRefreshEvent;
  setPlayerApiSimple: () => void;
  state: State;
}

export const NonPlayableVideo: FC<Props> = ({
  refreshComponent,
  setPlayerApiSimple,
  state
}) => {
  useEffect(() => {
    setPlayerApiSimple();
  }, [setPlayerApiSimple]);

  switch (state) {
    case State.PENDING_ONDEMAND:
      return <PendingOnDemand />;
    case State.PENDING_EVENT:
      return <PendingEvent refreshComponent={refreshComponent} />;
    case State.GONE:
      return <Gone />;
    case State.BLOCKED:
      return <Blocked />;
    case State.IDENTIFICATION:
      return <Identification refreshComponent={refreshComponent} />;
    case State.NOT_ALLOWED:
    case State.NOT_ALLOWED_CHANNEL:
      return <NotAllowed>{null}</NotAllowed>;
    default:
      return <Error />;
  }
};
